<h1 mat-dialog-title>{{ title }}</h1>
<hr>

<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
  <mat-dialog-content>
    <div class="row">
      <div class="col-12 col-sm-4 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nombre Reporte</mat-label>
          <input matInput formControlName="reporte" placeholder="Nombre Reporte"
            (blur)="form.controls['reporte'].markAsTouched()" uppercase alphanumericOnly maxlength="50">
          <mat-error *ngIf="isValidField('reporte')">
            {{ getFieldError('reporte') }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-4 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Formato</mat-label>
          <input matInput formControlName="formato" placeholder="Formato"
            (blur)="form.controls['formato'].markAsTouched()" uppercase alphanumericOnly maxlength="50">
          <mat-error *ngIf="isValidField('formato')">
            {{ getFieldError('formato') }}
          </mat-error>
        </mat-form-field>
      </div>
            <div class="col-12 col-sm-4 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Versión</mat-label>
          <input matInput formControlName="version" placeholder="Versión"
            (blur)="form.controls['version'].markAsTouched()" uppercase alphanumericOnly maxlength="50">
          <mat-error *ngIf="isValidField('version')">
            {{ getFieldError('version') }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" class="m-1" type="submit" *ngIf="mostrarBoton">
      <i class="fa fa-save"></i> Guardar
    </button>
    <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
      <i class="fa fa-remove fa-solid"></i> Cancelar
    </button>
  </mat-dialog-actions>
</form>